import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home.vue'
import Logo from '@/pages/Logo.vue'
import Jtgk from '@/pages/Jtgk.vue'
import Cyl from '@/pages/Cyl.vue'
import Cpxz from '@/pages/Cpxz.vue'
import Cpxq from '@/pages/Cpxq.vue'
import Qywh from '@/pages/Qywh.vue'
import Hzhb from '@/pages/Hzhb.vue'
import Lxwm from '@/pages/Lxwm.vue'
import Fzxw from '@/pages/Fzxw.vue'
import Cpfz from '@/pages/Cpfz.vue'
import Cpxh from '@/pages/Cpxh.vue'
import Xxpl from '@/pages/Xxpl.vue'
import Lxdt from '@/pages/Lxdt.vue'
import Gxqy from '@/pages/Gxqy.vue'
import Homes from '@/pages/Homes.vue'
import Group from '@/pages/Group.vue'
import Culture from '@/pages/Culture.vue'
import Parnter from '@/pages/Parnter.vue'
import Contact from '@/pages/Contact.vue'
import Products from '@/pages/Products.vue'
import Disclosure from '@/pages/Disclosure.vue'
import Industrial from '@/pages/Industrial.vue'
import Developing from '@/pages/Developing.vue'
import NewDetails from '@/pages/NewDetails.vue'
import Fzproducts from '@/pages/Fzproducts.vue'
import Xhproducts from '@/pages/Xhproducts.vue'
import Fsproducts from '@/pages/Fsproducts.vue'
import Ruanzhu from '@/pages/Ruanzhu.vue'
import Homepage from '@/pages/Homepage.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: '/logo',
      children: [
        {
          path: '/logo',
          name: 'Logo',
          component: Logo
        },
        {
          path: '/jtgk',
          name: 'Jtgk',
          component: Jtgk
        },
        {
          path: '/cyl',
          name: 'Cyl',
          component: Cyl
        },
        {
          path: '/cpxz',
          name: 'Cpxz',
          component: Cpxz
        },
        {
          path: '/qywh',
          name: 'Qywh',
          component: Qywh
        },
        {
          path: '/lxwm',
          name: 'Lxwm',
          component: Lxwm
        },
        {
          path: '/hzhb',
          name: 'Hzhb',
          component: Hzhb
        },
        {
          path: '/fzxw',
          name: 'Fzxw',
          component: Fzxw
        },
        {
          path: '/cpfz',
          name: 'Cpfz',
          component: Cpfz
        },
        {
          path: '/cpxh',
          name: 'Cpxh',
          component: Cpxh
        },
        {
          path: '/cpxq',
          name: 'Cpxq',
          component: Cpxq
        },
        {
          path: '/xxpl',
          name: 'Xxpl',
          component: Xxpl
        }
      ]
    },
    {
      path: '/lxdt',
      name: 'Lxdt',
      component: Lxdt
    },
    {
      path: '/gxqy',
      name: 'Gxqy',
      component: Gxqy
    },

    {
      path: '/homepage',
      name: 'Homepage',
      component: Homepage,
      redirect: '/homes',
      children: [
        {
          path: '/homes',
          name: 'Homes',
          component: Homes
        },
        {
          path: '/group',
          name: 'Group',
          component: Group
        },
        {
          path: '/products',
          name: 'Products',
          component: Products
        },
        {
          path: '/industrial',
          name: 'Industrial',
          component: Industrial
        },
        {
          path: '/developing',
          name: 'Developing',
          component: Developing
        },
        {
          path: '/culture',
          name: 'Culture',
          component: Culture
        },
        {
          path: '/parnter',
          name: 'Parnter',
          component: Parnter
        },
        {
          path: '/Disclosure',
          name: 'Disclosure',
          component: Disclosure
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/newDetails',
          name: 'NewDetails',
          component: NewDetails
        },
        {
          path: '/fzproducts',
          name: 'Fzproducts',
          component: Fzproducts
        },
        {
          path: '/xhproducts',
          name: 'Xhproducts',
          component: Xhproducts
        },
        {
          path: '/fsproducts',
          name: 'Fsproducts',
          component: Fsproducts
        },
        {
          path: '/ruanzhu',
          name: 'Ruanzhu',
          component: Ruanzhu
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js